import { Stack, Box } from "@mui/material";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Stars from "./Stars";
import SeoHelmet from "../../Components/SeoHelmet";
import { useGetPagesSeoApiQuery } from "../../Store/api/rtk";

export default function MainLayout() {
  const loc = useLocation();
  const doNotFetchPaths = [
    "product-details",
    "category-details",
    "brand-details",
    "blog-details",
    "course-details",
  ];

  const {
    data: seoData,
    isSuccess,
    isLoading,
  } = useGetPagesSeoApiQuery(
    { route: loc.pathname },
    {
      refetchOnMountOrArgChange: true,
      skip: doNotFetchPaths?.includes(loc.pathname?.split("/")?.at(1)),
    },
  );
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [loc.pathname]);

  const seo = isSuccess && !isLoading ? seoData?.data : null;

  return (
    <>
      <SeoHelmet
        title="ویراتک آروند آریا"
        metaTitle={seo?.meta_title}
        metaKeywords={seo?.meta_keywords || "ویراتک آروند آریا"}
        metaDescription={seo?.meta_description || "ویراتک آروند آریا"}
        index={seo?.index !== undefined ? seo.index : true}
        follow={seo?.follow !== undefined ? seo.follow : true}
        ogTitle={seo?.og_title || "ویراتک آروند آریا"}
        ogDescription={seo?.og_description || "ویراتک آروند آریا"}
        ogType={seo?.og_type || "website"}
        ogUrl={seo?.og_url}
        ogImage={
          seo?.og_image?.file_name
            ? `${import.meta.env.VITE_URL}${seo.og_image.file_name}`
            : undefined
        }
        twitterTitle={seo?.twitter?.twitter_title}
        twitterDescription={seo?.twitter?.twitter_description}
        twitterCard={seo?.twitter?.twitter_card || "summary_large_image"}
        scheme={seo?.json_schema}
      />
      <Stack
        sx={{
          minHeight: "100svh",
          position: "relative",
          background:
            "linear-gradient(145deg, #0f1425 0%, #000000 50%, #17212a 100%)",
          overflow: "hidden",
        }}
      >
        <Stars />
        {/* Main Content */}
        <Stack
          sx={{
            position: "relative",
            zIndex: 10,
            minHeight: "100svh",
          }}
        >
          <Navbar />
          <Outlet />
        </Stack>
      </Stack>
    </>
  );
}
